module.exports = __webpack_public_path__ + "img/google-play.71c2bd9d.png";